import React, { useEffect, useState, useRef } from "react";
import aboutimage from "../images/pageabout.jpg";
import groupimage from "../images/ABOUTGROUP.jpg";
import "./about.css";

const About = () => {
  // Counter logic
  const [startCount, setStartCount] = useState(false);
  const counterRef = useRef(null);

  const counters = [
    { id: 1, target: 20, label: "Apartments Sold", suffix: "+" },
    { id: 2, target: 1500, label: "Satisfied Clients", suffix: "+" },
    { id: 3, target: 100, label: "Houses Rented", suffix: "+" },
    { id: 4, target: 50, label: "Listed Properties", suffix: "+" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setStartCount(true);
      },
      { threshold: 0.5 }
    );

    if (counterRef.current) observer.observe(counterRef.current);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const AnimatedCounter = ({ target, suffix }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (startCount) {
        let start = 0;
        const duration = 2000; // 2 seconds
        const increment = target / (duration / 20);

        const timer = setInterval(() => {
          start += increment;
          if (start >= target) {
            setCount(target);
            clearInterval(timer);
          } else {
            setCount(Math.ceil(start));
          }
        }, 20);

        return () => clearInterval(timer);
      }
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startCount, target]);

    return <span>{count}{suffix}</span>;
  };

  return (
    <div>
      <h2 className="textblack p2 text-center">WHO WE ARE</h2>
      <h1 className="textblack p2 text-center">E.A.EKANEM CONSULTING</h1>

      <section className="container">
        <article className="text-justify">
          <p>
            E.A. Ekanem Consulting (EAEC) is a boutique Estate Surveying and
            Valuation Firm catering to clients who want unique solutions tailor
            made to their specific needs. EAEC has subsidiary businesses,
            including Pivot Real Estate Investments and Professional Services
            Limited—Abuja’s upcoming leading professional property services
            group—as well as Exemplar, our ministry/CSR division.
          </p>
          <p>
            Led by a team of multidisciplinary experts, E.A. Ekanem Consulting
            stands out by accompanying clients through every phase of the real
            estate process, building lasting relationships founded on value,
            trust, and transparency. Our combined management experience spans
            over 50 years, ensuring competence, market intelligence, and
            integrity in every project.
          </p>
        </article>

        <article className="visionmission">
          <div className="vision">
            <h2>OUR VISION</h2>
            <p>
              To be prime examples of global best practices, professionalism,
              and integrity in the real estate sector.
            </p>
          </div>
          <div className="mission">
            <h2>OUR MISSION</h2>
            <p>
              To foster improved quality of professional services via a
              well-motivated team delivering personalized and gratifying client
              experiences every time.
            </p>
          </div>
        </article>

        <div className="pageaboutcontainer">
          <article className="aboutleft">
            <h1 className="abouttext">Responsibility</h1>
            <p className="text-justify p1-about">
              At E.A. Ekanem Consulting (EAEC), we hold ourselves to the highest
              standards of integrity, professionalism, and service. Guided by
              Christian values, we prioritize ethical practices, sustainable
              growth, and social impact through our Exemplar initiatives. We
              build trust, foster meaningful relationships, and create lasting
              value for clients, investors, and communities.
            </p>
          </article>
          <article className="about-img-container">
            <img
              className="about-img"
              src={aboutimage}
              alt="real estate nigeria"
            />
          </article>
        </div>

        <h2 className="textblack p2 text-center">OUR BUSINESS</h2>
        <p className="text-justify p1-about">
          EAEC offers Property Valuation, Commercial Brokerage, Retail Leasing &
          Management, Property Development Finance Brokerage, Research,
          Advisory, Asset Management, Project Management, Facilities Management,
          and other corporate real estate services in Nigeria.
        </p>
      </section>

      <img src={groupimage} alt="Real estate nigeria" />

      <article className="container">
        <h2 className="textblack p2 text-center">OUR CULTURE & CORE VALUES</h2>
        <p className="textblack p2 text-center">
          Our culture of PIVOT is embodied in our core values and defines how we
          stand out in the industry.
        </p>
        <ul className="corevalues">
          <li>
            <b>Proactive Client Interaction:</b> We uphold world-class standards
            that reflect professionalism and intentional value addition.
          </li>
          <li>
            <b>Innovation & Improvement:</b> We are constantly evolving to
            deliver excellence and improve our clients’ experiences.
          </li>
          <li>
            <b>Value Addition:</b> We prioritize people and genuine care in all
            our interactions.
          </li>
          <li>
            <b>Others:</b>Integrity, Technology & Relationships Trust, efficiency, and
            results drive our approach to sustainable business.
          </li>
          <li>
            <b>Talent:</b> We leverage collaboration and diversity to achieve
            exceptional outcomes.
          </li>
        </ul>
      </article>

      {/* ✅ Counter Section integrated here */}
      <section className="counter" ref={counterRef}>
        <div className="counter-overlay"></div>
        <div className="counter-content">
          {counters.map((item) => (
            <div key={item.id} className="counter-box">
              <div className="counter-line"></div>
              <h2>
                <AnimatedCounter target={item.target} suffix={item.suffix} />
              </h2>
              <p>{item.label}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
